import { CSPUrlsMap } from '../routes/CSPUrlsMap';

export const ProfileSectionsMap = (isNotificationPreferencesEnabled, isSsoAuthentication = false) => ({
  accountDetails: {
    heading: 'Account details',
    url: CSPUrlsMap.accountDetails.url,
    icon: 'user-outline'
  },
  vetDetails: {
    heading: 'Vet details',
    url: CSPUrlsMap.vetDetails.url,
    icon: 'veterinarian',
    title: 'My vets',
    description: 'Add details of your current and previous vets so we can contact them if required.'
  },
  notificationPreferences: {
    heading: 'Notification preferences',
    url: CSPUrlsMap.notificationPreferences.url,
    icon: 'warning-triangle',
    hideItem: !isNotificationPreferencesEnabled
  },
  logout: {
    heading: isSsoAuthentication ? 'Back to My Insurance Portal' : 'Logout',
    url: CSPUrlsMap.logout.url,
    icon: 'logout'
  }
});
